import { render } from "./ChargeSerialCharge.vue?vue&type=template&id=179f7786&ts=true"
import script from "./ChargeSerialCharge.vue?vue&type=script&lang=ts"
export * from "./ChargeSerialCharge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__